import React from "react";
import Upload from "./Upload";
import Historico from "./HistoricoImportacao";

console.log("TESTE-INFRA")

function Importacao({ cpf }) {    
  return (
    <>
      <Upload cpf={cpf} />
      <Historico
        cpf={cpf}
      />
    </>
  );
}

export default Importacao;
